import {
  Spin, Tooltip, Card, Collapse, Tag,
} from 'antd';
import { useLocation } from 'react-router-dom';
import { CheckOutlined, CloseOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import qs from 'query-string';
import { useRequest } from 'ahooks';
import { isEmpty } from 'lodash';
import { getTransformationApplyDetail } from '@/services/transformationFinancing';
import FileDownload from '@/components/FileDownload/FileDownload';
import { getDictType } from '@/services/common';
import { BUSINESS_TYPE, PROJECT_TYPE } from '@/utils/mappingDict';
import DictionaryMatching from '@/components/DictionaryMatching/DictionaryMatching';
import '../MajorProjectTimeline.less';
import './index.less';

const obj = {
  0: 'processing', 2: 'error', 9: 'cancel', 1: 'success', // status 为0正常状态，进行中UI为实心数字； 1 拒绝； 2取消； 3：所有流程完成
};

const defaultParams = [PROJECT_TYPE, BUSINESS_TYPE].join(',');
export default function Timeline() {
  const { search } = useLocation();
  const { id } = qs.parse(search);

  const { data = {}, loading } = useRequest(() => getTransformationApplyDetail(id));

  const { data: dict = {} } = useRequest(getDictType, { // 筛选项字典
    defaultParams: [defaultParams],
  });

  function getIcon(status, index) {
    if (status === 0) {
      return index;
    } if (status === 2 || status === 9) {
      return <CloseOutlined />;
    }
    return <CheckOutlined />;
  }

  return (
    <Spin spinning={loading}>
      <div className="transformation-project-timeline">
        <div className="myapplication-detail__title">进度查询</div>
        <div className="myapplication-detail__sub-title">申请信息</div>
        <Card title="企业信息">
            <div className="myapplication-detail__grid">
                <div>
                  企业名称：
                  {data?.applicantName}
                </div>
                <div>
                  统一社会信用代码：
                  {data?.applicantNo}
                </div>
                <div>
                  所属行业：
                  {data?.industryIds}
                </div>
                <div>
                  主营业务类型：
                  <DictionaryMatching dictionary={dict?.businessType} value={data?.businessType} />
                </div>
            </div>
        </Card>
        <Card title="项目信息" style={{ marginTop: 10 }}>
          <div className="myapplication-detail__grid">
            <div>
              项目名称：
              {data?.projectName}
            </div>
            <div>
              建设性质：
              <DictionaryMatching dictionary={dict[PROJECT_TYPE]} value={data?.projectType} />
            </div>
            <div>
              项目所在地：
              {`${data?.provinceCode}-${data?.cityCode}-${data?.areaCode}`}
            </div>
            <div>
              资本金（万元）：
              {data?.selfOwnedFunds}
            </div>
            <div>
              财政资金（万元）：
              {data?.financialFunds}
            </div>
            <div>
              贷款总需求（万元）：
              {data?.totalLoanDemand}
            </div>
            <div>
              项目投资总额（万元）：
              {data?.projectSum}
            </div>
            <div>
              资金使用期限（月）：
              {data?.capitalTerm}
            </div>
            <div>
              联系人：
              {data?.contactPerson}
            </div>
            <div>
              联系方式：
              {data?.contactTel}
            </div>
            <div>
              融资需求类型：
              {data?.financingIds}
            </div>
            <div>
              项目建设内容：
              {data?.projectContent}
            </div>
            <div hidden={isEmpty(data?.supportingFiles)} style={{ display: 'flex' }}>
              <div style={{ flexShrink: 0 }}>财政投入佐证材料：</div>
              <div>
                {data?.supportingFiles?.map((item, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <FileDownload key={index} appendixName={item.fileName} fileUrl={item.fileUrl} />
                ))}
              </div>
            </div>
            <div style={{ display: 'flex' }}>
              <div style={{ flexShrink: 0 }}>附件：</div>
              <div>
                {isEmpty(data?.appendixFiles) ? (
                  '无'
                ) : (
                  data?.appendixFiles?.map((item, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <FileDownload key={index} appendixName={item.fileName} fileUrl={item.fileUrl} />
                  ))
                )}
              </div>
            </div>
          </div>
        </Card>
        <div className="myapplication-detail__sub-title">
          智能识别结果
          <Tooltip title="系统转型识别模型根据填报信息智能识别项目是否为潜在转型项目，最终认定结果与具体转型目录需专家复核。">
              <QuestionCircleOutlined />
          </Tooltip>
        </div>
        <div>
          <div style={{ marginBottom: 20 }}>
            模型识别结果：
            {data?.aiRecognitionVo ? (
              <Tag color="green">
                {data?.aiRecognitionVo?.result ? '潜在转型项目' : '非潜在转型项目'}
              </Tag>
            ) : '模型识别中'}

          </div>
          <Collapse defaultActiveKey={['1']}>
                <Collapse.Panel header="转型金融支持经济活动目录（农业）" key="1">
                  <div className="transformation-project_row">
                    <div>
                      转型领域：
                      {data?.aiRecognitionVo?.sector || '-'}
                    </div>
                    <div>
                      转型路径：
                      {data?.aiRecognitionVo?.path || '-'}
                    </div>
                    <div className="transformation-project_row-ai">大语言模型智能分析</div>
                    <div>{data?.aiRecognitionVo?.detail || '-'}</div>
                  </div>
                </Collapse.Panel>
          </Collapse>
        </div>
        <div hidden={data?.status === 0 || data?.status === 24}>
          <div className="myapplication-detail__sub-title">专家认定结果</div>
          <div>
            认定结果：
            <Tag color="green">{data?.status === 1 ? '转型项目' : '非转型项目'}</Tag>
          </div>
          <div className="myapplication-detail__grid" style={{ marginTop: 12 }}>
            <div hidden={!data?.reviewFinancingIds}>
              转型路径：
              {data?.reviewFinancingIds}
            </div>
            <div>
              审核意见：
              {data?.operateReason}
            </div>
          </div>
        </div>
        <div className="myapplication-detail__sub-title">进度信息</div>
        <div className="major-project-timeline">
          {
            data?.userLogs?.map((item, index) => (
              <div className={`timeline-item timeline-item-${index + 1 === data?.userLogs.length && obj?.[item.status]}`}>
                <div className="timeline-icon">
                  {
                    index + 1 === data?.userLogs.length
                      ? (
                        <>
                          {getIcon(item.status, index + 1)}
                        </>
                      ) : <CheckOutlined />
                  }
                </div>
                <div className="timeline-cont">
                  <div className="timeline-title">{item.title}</div>
                  <div dangerouslySetInnerHTML={{ __html: item.remark }} />
                  <div>{item.operateTime}</div>
                </div>

              </div>
            ))
          }
        </div>
      </div>
    </Spin>
  );
}
